import confetti from "canvas-confetti";

const BRAND_COLORS = ["#8B5CF6", "#A78BFA", "#C4B5FD", "#FBBF24", "#FFFFFF"];

export function fireConfetti() {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  confetti({ particleCount: 130, spread: 80, origin: { y: 0.6 }, colors: BRAND_COLORS, zIndex: 200 });
  setTimeout(() => confetti({ particleCount: 60, angle: 60, spread: 60, origin: { x: 0, y: 0.7 }, colors: BRAND_COLORS, zIndex: 200 }), 200);
  setTimeout(() => confetti({ particleCount: 60, angle: 120, spread: 60, origin: { x: 1, y: 0.7 }, colors: BRAND_COLORS, zIndex: 200 }), 380);
}

export function playCrateSound() {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const t = ctx.currentTime;

    // low thud — crate popping open
    const thud = ctx.createOscillator();
    const thudGain = ctx.createGain();
    thud.type = "sine";
    thud.frequency.setValueAtTime(140, t);
    thud.frequency.exponentialRampToValueAtTime(45, t + 0.18);
    thudGain.gain.setValueAtTime(0.35, t);
    thudGain.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);
    thud.connect(thudGain).connect(ctx.destination);
    thud.start(t);
    thud.stop(t + 0.25);

    // ascending chime arpeggio
    [523.25, 659.25, 783.99, 1046.5].forEach((freq, i) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      const start = t + 0.12 + i * 0.09;
      osc.type = "triangle";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(0.22, start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.55);
      osc.connect(gain).connect(ctx.destination);
      osc.start(start);
      osc.stop(start + 0.6);
    });

    // shimmer sparkle
    const length = ctx.sampleRate * 0.35;
    const buffer = ctx.createBuffer(1, length, ctx.sampleRate);
    const data = buffer.getChannelData(0);
    for (let i = 0; i < length; i++) data[i] = (Math.random() * 2 - 1) * (1 - i / length);
    const noise = ctx.createBufferSource();
    noise.buffer = buffer;
    const filter = ctx.createBiquadFilter();
    filter.type = "highpass";
    filter.frequency.value = 4500;
    const noiseGain = ctx.createGain();
    noiseGain.gain.setValueAtTime(0.1, t + 0.15);
    noiseGain.gain.exponentialRampToValueAtTime(0.0001, t + 0.5);
    noise.connect(filter).connect(noiseGain).connect(ctx.destination);
    noise.start(t + 0.15);

    setTimeout(() => ctx.close(), 1800);
  } catch {
    // audio blocked or unsupported — stay silent
  }
}

export function celebrate() {
  playCrateSound();
  fireConfetti();
}
